module.exports = __webpack_public_path__ + "img/carshina22_05.6a6bf0ef.jpg";